module.exports = __webpack_public_path__ + "5d30410f98ed2dd2a42b93d93ca299a5.svg";